<template>
    <v-container>
        <h1 class="titulo mb-3">RESTRIÇÕES DE VENDA</h1>
        <v-card class="card">
            <v-card-text>
                <m-form ref="form">
                    <v-row class="ml-1">
                        <v-switch
                                v-model="model.tipo_restricao"
                                :label="`Tipo de Restrição: ${model.tipo_restricao ? tipos_restricao.grupo.label : tipos_restricao.plano_venda.label}`"
                                @change="model.cd_restricao_vendas = ''"
                        ></v-switch>
                    </v-row>
                    <v-row>
                        <v-col cols="6" md="4">
                            <m-text-field :label="`Informe o ${model.tipo_restricao ? tipos_restricao.grupo.label : 'Código do '+ tipos_restricao.plano_venda.label}: `"
                                          class="required"
                                          :rules="[$rules.required, backendValidation, $rules.maxlength10Char]"
                                          v-input-filter="model.tipo_restricao ? [$filters.numeric] : [$filters.textnumeric]"
                                          v-model="model.cd_restricao_vendas"
                                          maxlength="10"
                                          outlined
                                          v-uppercase
                                          @change="clearValidation(backendError)"
                            />
                        </v-col>

                        <v-col cols="6" md="4">
                            <v-autocomplete label="Selecione a Unidade de Negócio:"
                                            id="SelectUnidadeNegocio"
                                            item-text="label"
                                            item-value="value"
                                            outlined
                                            :disabled="restricoesPlanoVenda.todos"
                                            :filled="restricoesPlanoVenda.todos"
                                            clearable
                                            :items="dadosRestricoesPlanoVenda.unidades_negocio"
                                            v-model="restricoesPlanoVenda.unidade_negocio"
                            />
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-select label="Selecione a Marca:"
                                      id="SelectMarca"
                                      item-text="label"
                                      item-value="value"
                                      outlined
                                      :disabled="restricoesPlanoVenda.todos"
                                      :filled="restricoesPlanoVenda.todos"
                                      clearable
                                      :items="dadosRestricoesPlanoVenda.marcas"
                                      v-model="restricoesPlanoVenda.marca"
                            />
                        </v-col>
                        <v-col cols="6" md="4">
                            <DynamicSelect label="Selecione o P.V:"
                                           id="SelectPontoVenda"
                                           v-model="restricoesPlanoVenda.ponto_venda"
                                           endpoint="/dynamic-selects/pontos_venda/id"
                                           :disabled="restricoesPlanoVenda.todos"
                                           :filled="restricoesPlanoVenda.todos"
                                           :multiple="false"
                            />
                        </v-col>
                        <v-col cols="6" md="4" class='d-flex align-center'>
                            <v-checkbox
                                    class="mt-4"
                                    label="Restringir para todos"
                                    @change="handleChangeTodos"
                                    v-model="restricoesPlanoVenda.todos"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row class="mb-4">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn class="transition" color="primary" rounded @click="inserir">
                                Salvar
                            </v-btn>
                        </v-col>
                    </v-row>
                </m-form>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition ml-1" color="primary" rounded @click="toggleFiltro">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn class="transition mr-1" color="primary" rounded @click="exportarExcel">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        Salvar Relatório
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" v-show="filter_open" class="mt-4 ml-2">
                        <v-row>
                            <v-col cols="6">
                                <m-text-field outlined
                                              label="Código restrição (Plano/Grupo): "
                                              v-model="filters.cd_restricao_vendas"
                                              v-uppercase
                                              maxlength="10"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete label="Un. Negócio:"
                                                id="SelectFilterUnMarca"
                                                item-text="label"
                                                item-value="value"
                                                outlined
                                                clearable
                                                :items="dadosRestricoesPlanoVenda.unidades_negocio"
                                                v-model="filters.restricao_un_negocio"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-select label="Marca:"
                                          id="SelectFilterMarca"
                                          item-text="label"
                                          item-value="value"
                                          outlined
                                          clearable
                                          :items="dadosRestricoesPlanoVenda.marcas"
                                          v-model="filters.restricao_marcas"
                                />
                            </v-col>
                            <v-col cols="6">
                                <DynamicSelect label="P.V:"
                                               id="SelectFilterPontoVenda"
                                               v-model="filters.restricao_pv"
                                               endpoint="/dynamic-selects/pontos_venda/id"
                                               :multiple="false"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-select label="Tipo de restrição:"
                                          id="SelectTipoDeRestricao"
                                          item-text="label"
                                          item-value="value"
                                          outlined
                                          clearable
                                          :items="tipos_restricao_array"
                                          v-model="filters.tipo_restricao"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="justify-space-between">
                            <v-col cols="6" md="3">
                                <v-btn color="secondary" block @click="limpar">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" md="3">
                                <v-btn color="primary" block @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <DataTable ref="datatable" url="/painel/grupos_restricao_venda/listar"
                           class="pt-2 data-table-overlow"
                           :headers="headers"
                           :params="params"
                           :filter="dtFiltro">
                    <template v-slot:items="{item}">
                        <td>{{ item.tipo_restricao }}</td>
                        <td>{{ item.cd_restricao_vendas }}</td>
                        <td>{{ getFlavor(item.flavor) }}</td>
                        <td>{{ getUnidade(item.restricao_un_negocio) }}</td>
                        <td>
                            <v-tooltip v-if="exibirIconePv(item)" bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon size="16" v-on="on" color="primary">mdi-help-box</v-icon>
                                </template>
                                <span>Não foi possível buscar as informações do PV, portanto será exibido o ID do mesmo.</span>
                            </v-tooltip>
                            {{ getPv(item) || '-' }}
                        </td>
                        <td>
                            <div class="d-flex justify-center">
                                <v-icon size="24" :color="item.restricao_todos ? 'secondary' : 'error'">{{ item.restricao_todos ? 'mdi-check' : 'mdi-close' }}</v-icon>
                            </div>
                        </td>
                        <td>
                            <v-col xs12>
                                <v-btn icon>
                                    <v-icon @click="deletar(item.id,item.cd_restricao_vendas)">ol-delete</v-icon>
                                </v-btn>
                            </v-col>
                        </td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { alert, notification, sleep, replaceUndefinedKeysWithNull } from '@/plugins/helpers'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import * as Qs from 'qs'
  export default {
    name: 'GruposVendas',
    data: () => ({
      backendValidation: false,
      backendError: {
        field: [],
        msgError: []
      },
      filter_open: false,
      pagination: {
        sortBy: [ 'cd_restricao_vendas' ], descending: [ true ]
      },
      dtFiltro: {},
      model: {
        cd_restricao_vendas: '',
        tipo_restricao: false
      },
      restricoesPlanoVenda: {
        marca: null,
        unidade_negocio: null,
        ponto_venda: null,
        todos: false
      },
      dadosRestricoesPlanoVenda: {
        marcas: [],
        unidades_negocio: []
      },
      headers: [
        { text: 'Tipo de restrição', value: 'tipo_restricao' },
        { text: 'Código da restrição (Plano/Grupo)', value: 'cd_restricao_vendas' },
        { text: 'Marca', value: 'restricao_marcas' },
        { text: 'Un. Negócio', value: 'restricao_un_negocio' },
        { text: 'P.V', value: 'restricao_pv' },
        { text: 'Restrição para Todos', value: 'restricao_todos' },
        { text: '', value: '' }
      ],
      filters: {
        cd_restricao_vendas: '',
        restricao_marcas: '',
        restricao_un_negocio: '',
        restricao_pv: '',
        tipo_restricao: ''
      }
    }),
    computed: {
      params () {
        return { pagination: this.pagination, include: ['flavor'] }
      },
      unidades () {
        return this.$session.get('unidades').map(unidade => ({ value: unidade.id_unidade_negocio, label: `${unidade.cd_unidade_negocio} - ${unidade.nm_unidade_negocio}` }))
      },
      tipos_restricao () {
        return {
          grupo: { label: 'Grupo', value: 'Grupo' },
          plano_venda: { label: 'Plano de Venda', value: 'Plano de Venda' },
          todos: { label: 'Todos', value: '' }
        }
      },
      tipos_restricao_array () {
        return Object.values(this.tipos_restricao)
      }
    },
    async mounted () {
      await this.getInputsData()
    },
    methods: {
      getFlavor (flavor) {
        if (flavor) {
          return flavor.nome_amigavel
        } else {
          return '-'
        }
      },
      getUnidade (id_unidade) {
        if (id_unidade) {
          const unidade = this.$session.get('unidades').find((unidade) => unidade.id_unidade_negocio === +id_unidade)
          if (!unidade) {
            return '-'
          }
          return unidade.cd_unidade_negocio + ' - ' + unidade.nm_unidade_negocio
        } else {
          return '-'
        }
      },
      exibirIconePv (item) {
        return item.restricao_pv && !(!!item.cd_ponto_venda && !!item.nm_ponto_venda)
      },
      getPv (item) {
        if (item.restricao_pv && item.cd_ponto_venda && item.nm_ponto_venda) {
          return item.cd_ponto_venda + ' - ' + item.nm_ponto_venda
        } else {
          return item.restricao_pv
        }
      },
      handleChangeTodos () {
        this.limparTodosOsCamposMenosTodos()
      },
      limparTodosOsCamposMenosTodos () {
        this.restricoesPlanoVenda.marca = null
        this.restricoesPlanoVenda.unidade_negocio = null
        this.restricoesPlanoVenda.ponto_venda = null
      },
      resetarRestricoes () {
        this.restricoesPlanoVenda.marca = null
        this.restricoesPlanoVenda.unidade_negocio = null
        this.restricoesPlanoVenda.ponto_venda = null
        this.restricoesPlanoVenda.todos = false
      },
      async getInputsData () {
        const getMarcas = this.getMarcas()
        this.dadosRestricoesPlanoVenda.unidades_negocio = this.unidades
        return Promise.all([getMarcas])
      },
      async getMarcas () {
        return new Promise((resolve, reject) => {
          this.$http.get('/painel/flavors/get-all-formatados')
            .then((response) => {
              this.dadosRestricoesPlanoVenda.marcas = response.data.flavors
              resolve()
            })
            .catch((error) => {
              notification('error', 'Prezado parceiro, ocorreu um erro ao carregar as marcas, sugerimos recarregar a página e caso o erro persista entre em contato com a Área de Suporte.')
              reject(error)
            })
        })
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      async inserir () {
        const form = this.$refs.form
        if (!this.verificaSeSelecionouAlgumaCondicao()) {
          notification('warning', 'É necessário selecionar ao menos uma restrição para prosseguir.')
          return
        }
        if (form.validate()) {
          alert({
            text: `Tem certeza que deseja inserir a restrição de venda ${this.model.cd_restricao_vendas}?`,
            buttons: {
              'Cancelar': () => true,
              'Confirmar': async () => {
                try {
                  this.restricoesPlanoVenda.todos = !!this.restricoesPlanoVenda.todos
                  const restricao_grupo = this.model.tipo_restricao
                  await this.$http.post('/painel/grupos_restricao_venda/inserir', { tipo_restricao: restricao_grupo ? this.tipos_restricao.grupo.value : this.tipos_restricao.plano_venda.value, cd_restricao_vendas: this.model.cd_restricao_vendas, restricoes: replaceUndefinedKeysWithNull(this.restricoesPlanoVenda) })

                  this.$refs.datatable.reload()
                  this.model.cd_restricao_vendas = ''
                  this.resetarRestricoes()
                  this.$refs.form.reset()
                  notification(AlertTypes.SUCCESS, restricao_grupo ? 'Grupo exclusivo cadastrado com sucesso!' : 'Código do plano de venda inserido com sucesso.')
                } catch (err) {
                  if (err?.response?.data?.Erro_Validacao) {
                    notification('error', err.response.data.Erro_Validacao)
                  } else {
                    notification('error', 'Foi encontrado um problema ao inserir a restrição de venda, sugerimos tentar novamente e caso o erro continue entre em contato com a Área de Suporte.')
                  }
                }
              }
            }
          })
        } else {
          form.resetValidation()
          sleep(100).then(() => form.validate())
        }
      },
      verificaSeSelecionouAlgumaCondicao () {
        return (this.restricoesPlanoVenda.marca !== null && this.restricoesPlanoVenda.marca !== undefined) ||
          (this.restricoesPlanoVenda.unidade_negocio !== null && this.restricoesPlanoVenda.unidade_negocio !== undefined) ||
          (this.restricoesPlanoVenda.ponto_venda !== null && this.restricoesPlanoVenda.ponto_venda !== undefined) ||
          (this.restricoesPlanoVenda.todos !== false && this.restricoesPlanoVenda.todos !== undefined)
      },
      async deletar (id, cd_restricao_vendas) {
        try {
          alert({
            text: `Deseja remover essa restrição para a restrição de venda ${cd_restricao_vendas}?`,
            buttons: {
              'Cancelar': () => true,
              'Confirmar': async () => {
                await this.$http.delete(`/painel/grupos_restricao_venda/delete/${id}`).then(() => {
                  notification(AlertTypes.SUCCESS, 'Restrição de venda excluída com sucesso!')
                  this.$refs.datatable.reload()
                }).catch(() => {
                  this.errorDeletarRestricao()
                })
              }
            }
          })
        } catch (e) {
          this.errorDeletarRestricao()
        }
      },
      exportarExcel () {
        const filtros = { ...this.filters }

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/grupos_restricao_venda/exportar?${encoded_params}`)
      },
      errorDeletarRestricao () {
        notification('error', 'Foi encontrado um problema ao excluir a restrição de venda, sugerimos tentar novamente e caso o erro continue entre em contato com a Área de Suporte.')
      },
      filtrar () {
        if (this.$refs.filter.validate()) {
          this.dtFiltro = { ...this.filters }
        }
      },
      limpar () {
        this.filters = {
          cd_restricao_vendas: '',
          restricao_marcas: '',
          restricao_un_negocio: '',
          restricao_pv: ''
        }

        this.filtrar()
        this.filter_open = false
      },
      clearValidation (backendError) {
        this.backendValidation = false
        backendError.field.forEach((item, i) => {
          if (item === this.model.cd_restricao_vendas) {
            this.backendValidation = backendError.msgError[i]
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
